module.exports = __webpack_public_path__ + "media/images/sp/staffs/qualified-06fb1f25c23f7fae63a54f7880a4beee.svg";